<docs>
  # HeaderCredit
  > The Header for credit page
  
  @author Kffein <contact@kffein.com>
</docs>

<script lang="ts">
import { templateRef } from "@vueuse/core";
import ArrowSvg from "assets/svg/arrow.svg?raw";
import { store as themeStore } from "pages/Thematique/store";
import useRouter from 'plugins/router';
import { store as appStore } from "store/app";
import useFlow from 'utils/flow';
import { gsap } from "vendors/gsap";
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from "vue-router";

export default defineComponent({
  name: "HeaderCredit",
  setup() {

    const route = useRoute();
    const { onInitUi } = useFlow();
    const router = useRouter()
    const { t } = useI18n();
    const el = templateRef<HTMLElement>("el");

    const disabled = computed(() => appStore.disabled);
    const isCreditRoute = computed(() => route.name === 'credit')

    onInitUi(() => {
      animateIn()
    });


    // Tween to display elements 
    const animateIn = () => {
      gsap.timeline()
        .add(() => {
          el.value.classList.remove("hidden");
        }, 0)
        .from(el.value, { yPercent: -150, ease: "power4.out", duration: 0.75 }, 0.4)
    }

    // Tween to hide elements 
    const animateOut = () => {
      el.value.classList.add("hidden");
    }

    const onBack = (e: PointerEvent) => {
      e.preventDefault();
      animateOut();

      if (window.history.length > 1) {
        
        gsap.timeline()
          .to(".page.credit", { opacity: 0, ease: "power4.out", duration: 1 }, 0)
          .add(() => {
            router.back();
          }, 1)
          .add(() => {
            if(themeStore.current) {
              appStore.setAppBgColor(themeStore.current?.bgColor)
            }
            else{
              let bgColor;
              
              if(themeStore.currentObject?.indexOf("bio") !== -1) {
                bgColor = "25, 32, 150";
              }
              else{
                bgColor = "253, 246, 250"                 
              }
        
              appStore.setAppBgColor(bgColor)
            }
          }, .5);
      } else {
        appStore.setPageTransition({ name: 'home' });
      }
    }


    return {
      t,
      isCreditRoute,
      disabled,
      ArrowSvg,
      onBack,
      gradientColor1: computed(() => `rgba(${appStore.bgColor}, 0)`),
      gradientColor2: computed(() => `rgba(${appStore.bgColor}, .79)`),
      gradientColor3: computed(() => `rgba(${appStore.bgColor}, 1)`),
    };
  },
});
</script>

<template>
  <header v-if="isCreditRoute"
          ref="el"
          class="HeaderCredit hidden"
  >
    <ui-button :label="t('LABELS.back')"
               theme="primary"
               class="back"
               :to="{ name: 'home' }"
               :icon="ArrowSvg"
               direction="left"
               tag="a"
               @click="onBack($event)"
    />
    <h4 class="title"
        :data-dark="false"
        v-html="'Crédits'"
    />
  </header>
</template>

<style lang="stylus" scoped>
  .HeaderCredit
    fixed top $gutter left $gutter
    f(center)
    width "calc(100% - ( 2* %s ))" % $gutter
    z-index $z-header
    opacity 1
    color $c-main
    trans(opacity)
    &:after
      position absolute
      content ''
      display block
      top 'calc(%s * -1)' % ($gutter)
      left 'calc(%s * -1)' % ($gutter)
      width 100vw
      z-index -1
      rp(height, 90px)
      trans(height)
      trans(background, $duration:1.5s)
      pointer-events none
      background 'linear-gradient(0deg, %s 0%, %s 49%, %s 100%)' % (v-bind(gradientColor1) v-bind(gradientColor2) v-bind(gradientColor3))
    &[data-intro="true"]
      opacity 1
    &[data-disabled="true"]
      pointer-events none

    &.hidden
      opacity 0
      pointer-events none

  .back.UiButton
    position absolute
    left 0px
    top 0px
    rp(padding-top, 10px)
    rp(padding-bottom, 10px)
   
  .title
    text-align center
    f-style("text16_thematique")
    text-transform uppercase
    margin 0 auto
    trans(transform, $duration:1.5s)
  </style>
